<template>
<div>
  <!-- BEGIN: Header-->
   <nav class="header-navbar navbar navbar-expand-lg align-items-center floating-nav navbar-light navbar-shadow" style="margin:0 !important;width:100% !important;height:64px !important;">
        <div class="navbar-container d-flex content align-items-center">
            <div class="bookmark-wrapper d-flex align-items-center">
                <ul class="nav navbar-nav d-xl-none">
                    <li class="nav-item">
                        <a class="nav-link menu-toggle" id="menutoggleview" href="#">
                        <menu-icon size="1.5x" class="custom-class ficon"></menu-icon>
                        </a>
                    </li>
                </ul>
                
            </div>
            <div class="docscantitle">
                <a v-if="!controlTowerUsers.includes(useremail)"  class="brand-logo"  href="#">
                    <img alt="" src="../../public/images/logo/IntelliBee-Logo.png"  height="52px" class="webviewlog">
                    <img alt="" src="../../public/images/logo/IntelliBee-Logo1.png"  height="40px" class="mobile_view_logo">
                </a>
                <a v-else class="brand-logo"  href="#">
                    <img alt="" src="../../public/images/logo/crossdock-logo.png"  height="52px" class="webviewlog">
                    <img alt="" src="../../public/images/logo/crossdock-logo.png"  height="40px" class="mobile_view_logo">
                </a>
            </div>
            <!-- <div class="nav-search  search_filtter_animation sarch_afterchange_design12">
                    <div class="search">
                        <input type="text" v-model="searchTerm" class="search-box" placeholder="Enter Package No ..." @keyup.enter="searchAll"/>
                        <button type="button" id="search_bar" v-on:click.stop.prevent="searchAll" ><search-icon size="1.5x" class="custom-class"></search-icon></button>
                    </div>
            </div> -->
            <!-- navbar-nav align-items-center  res_nav_navbar_content -->
            <ul class="nav navbar-nav align-items-center ml-auto navbarleft_section_m0">
                
                <li class="nav-item dropdown dropdown-user">
                    <a class="nav-link dropdown-toggle dropdown-user-link" id="dropdown-user" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div class="user-nav d-sm-flex ">
                            <span class="user-name font-weight-bolder">{{ capitalizeFirstletter(firstname) }} {{ capitalizeFirstletter(lastname) }}</span>
                            <span class="user-status">Admin</span>
                        </div>
                        <span class="avatar">
                            <img alt=""  class="round" src="../../public/images/portrait/small/blank-pro.png"  height="40" width="40">
                            <span class="avatar-status-online">
                            </span>
                        </span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdown-user">
                        <div  class="d-flex align-items-center dropdown-item " @click="handlePunchAction"> 
                            <a tabindex="4" v-if="userAttendanceData">
                                <em class="las la-stopwatch  custom-class mr-50 font-medium-4"></em>
                                Punch OUT
                            </a>
                            <a tabindex="4" v-else>
                                <em class="las la-user-clock custom-class mr-50 font-medium-4"></em>
                                Punch IN
                            </a>
                        </div>
                        <router-link to='/register' class="d-flex align-items-center dropdown-item ">
                            <a tabindex="4"  >
                                <em class="las la-user-plus custom-class mr-50 font-medium-4"></em>
                               Register
                            </a>
                         </router-link>
                         <a type="submit" class="dropdown-item"  tabindex="4" @click="LogSession()" >
                            <em class="las la-sign-out-alt  custom-class mr-50 font-medium-4" @click="LogSession()"></em>
                        
                            Logout
                        </a>
                    </div>
                </li>
                <li class="nav-item  dropdown-user userdownloadguide">
                    <a href="images/doc/IntelliLink_User_Manual.pdf" target="_blank" class="text-primary"  data-toggle="tooltip" title=" UserGuide">
                        <i class="las la-cloud-download-alt"></i>
                       <span class="moibleviewdownload"> UserGuide </span> 
                    </a>
                </li>
               
                </ul>
            </ul>
        </div>
    </nav>
    <!-- END: Header-->
</div> 

</template>
<script>
import axios from 'axios'

import { UserIcon } from 'vue-feather-icons'
import { PowerIcon } from 'vue-feather-icons'
import { MenuIcon, UserPlusIcon,SearchIcon } from 'vue-feather-icons'
import common_methods from "../utils/common_methods"
import searchMasterNameList from "../utils/searchMasterNameList"
import { EventBus } from '../main'

export default ({
    name:'Nav',
    mixins: [ common_methods, searchMasterNameList ],
    components:{
        UserIcon,
        PowerIcon,
        MenuIcon,
        UserPlusIcon,
        SearchIcon
    },
    data() {
        return {
            un:'',
            dept:'',
            profileurl :'',
            tokendata:null,
            email: null,
            firstname: null,
            lastname: null,
            searchTerm: null,
            userAttendanceData: null,
            useremail: "",
            controlTowerUsers: ['abhishek.khale@intellibees.com', 'nikhil@intellibees.in', 'atul.deokar@intellibees.com']
        }  
    } ,
    mounted(){
        
        var userdata = window.localStorage.getItem('userdata');
        if(userdata){
            userdata = JSON.parse(userdata)
            this.email = userdata.username
            this.useremail = userdata.username
            this.firstname = userdata.firstname
            this.lastname = userdata.lastname
            this.tokendata = window.localStorage.getItem("token");    
           // this.userAttendanceDetails()
        }else{
            this.$router.push('/login');
        }
    },
    methods: {
        searchAll() {
          console.log(this.searchTerm, 'search this')
          console.log(this.makeRequest)
          EventBus.$emit('searchTerm', this.searchTerm)
          if(!this.searchTerm || (this.searchTerm && !this.searchTerm.trim())) return
          let searchCode = this.searchTerm.trim().toUpperCase()
          this.$router.push({
              path: `/search-details?query=${searchCode}`, 
              query: { query: searchCode }, 
              params: { search: true }}
          ).catch(error => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
          });
        },
        userAttendanceDetails() {
            var userdata = window.localStorage.getItem('userdata');
            if(userdata){
                userdata = JSON.parse(userdata)
                this.empid = userdata.userid
                // this.apiURL="/profile/getProfileDetails"
                // this.input={
                //     empcode:this.empid,
                //     useremail: this.email
                // }
                // axios({
                //     'method': 'POST',
                //     'url': this.apiURL,
                //     'data':this.input,
                // })
                // .then(result => {             
                //     if(result.data.status){
                //         let response = result.data.data;
                        
                //         this.joiningdate=response.joiningdate
                //         this.employeeid = response.empid
                //         this.birthday = response.birthday
                //         this.reportingto = response.reportto
                //         this.year = response.year?(response.year+' yr ') : ''
                //         this.month = response.month?response.month+' mos':''
                //         this.totalexp =this.year+ ''+this.month

                //         this.un=response.firstname+' '+response.lastname
                //         this.dept = response.designation+' ['+response.department+']'
                //         this.email = response.emailid
                //         this.address = response.city+','+response.state+','+response.country
                //         this.mobilenumber = response.mobileno
                //         this.firstname=response.firstname
                //         this.lastname=response.lastname

                //     }
                // }).catch(e => {
                //     // console.log(e)
                // })
            }
            this.makeRequest("POST", "/attendance/get-user-attendance")
                .then(result => {
                    this.userAttendanceData = result.data.data
                })
                .catch(e => {
                    this.displayError(e)
                })
        },
        getProfilePic(imagepath) {
            var input =[]
            input.push({path:imagepath})
            let payload = {
                documents:input,
                empcode: this.empid,
                useremail: this.username
            };
            axios({
                'method': 'POST',
                'url': "/reimbursement/getdownloadlink",
                'data':payload,
            })
            .then((result) => {
            if(result.data.status) {
                if(result.data.data.length>0) {
                    this.profileurl =result.data.data[0].presignurl
                }
            }
            });
        },
        backtoHomepage: function() {
            this.$router.push({ path: "/home" }); 
        },
        backtoLoginpage: function() {
            localStorage.removeItem('reloaded');
            localStorage.removeItem('userdata');
            localStorage.removeItem('token');
            localStorage.removeItem('check');
            localStorage.removeItem('pagefeatures');
            localStorage.removeItem('sidebar');
            localStorage.removeItem('travel');
            this.$router.push({ path: "/login" }); 
        },

        LogSession(){
            // let payload = {
            //     emailid:this.email,
            //     empcode: this.empid,
            //     useremail: this.username
            // };
            // this.isLoading = true;    
            // let url = "/user/LogSession";
            // axios({
            //     method: "POST",
            //     url: url,
            //     data: payload,
            //     headers: { authorization: this.tokendata },
            // }).then((result) => {
            //     this.isLoading = false;
            // });
            this.backtoLoginpage()
        },
        capitalizeFirstletter(word) {
            if(!word)   return ""
            return word.slice(0,1).toUpperCase() + word.slice(1)
        },
        handlePunchAction() {
            let url = "/attendance/mark-user-attendance"
            this.makeRequest("POST", url, { action: 'PUNCH_IN'})
                .then(result => {
                    let message = result.data.message
                    this.sweetAlertSnackbar(message, 'success')
                })
                .catch(e => {
                    this.displayError(e)
                })
        },
        
    }
})
</script>
<style>
 .header-navbar .navbar-container ul.navbar-nav li.dropdown-user .dropdown-menu {
    width: 14rem!important;
    margin-top: 10px;
}
.feather-icon.position-relative .new-icon {
        stroke: #777777;
        width: 25px!important;
        height: 25px!important;
        display: inline-block
    }
    .feather-icon.position-relative .new-icon:hover {
        stroke: #28c76f;
    }
    .dark-layout .feather-icon.position-relative .new-icon{
      stroke: #fff;
    }
     .dark-layout .feather-icon.position-relative .new-icon:hover {
        stroke: #28c76f;
    }
    .new-icon:active {
        stroke: #91d5b0;
    }
    div.search input[type=text] {
        padding: 5px 10px;
    border: 1px solid hsla(0,0%,89.8%,.8392156862745098);
    width: 100%;
    background: #fff;
    font-size: 16px;
    border-radius: 6px;
    padding-right: 30px;
    transition: all .3s ease-in;
    }
    div.search input[type=text][data-v-dec378bc]:focus {
    width: 100%;
    transition: all .3s ease-in;
}
    div.search input[type=text]:focus {
     width: 100%;
     transition: all .3s ease-in;
    }
    .sarch_afterchange_design12{
        margin: 7px auto;
        width: 40%;
    }
   
    
    div.search::after {
        content: "";
        clear: both;
        display: table;
    }
@media (max-width: 768px) {
    .menu-open .navbar-nav {
        display: block !important;
    }
}
</style>